import { http } from "./http";
import { SeoActionResponse, SeoDashboard, SeoSettings } from "../types/seo";

export const SeoAPI = {
  async dashboard() {
    const res = await http.get<SeoDashboard>("/admin/seo");
    return res.data;
  },
  async getSettings() {
    const res = await http.get<SeoSettings>("/admin/seo/settings");
    return res.data;
  },
  async updateSettings(payload: Record<string, unknown>) {
    const res = await http.put<SeoSettings>("/admin/seo/settings", payload);
    return res.data;
  },
  async testConnection() {
    const res = await http.post<SeoActionResponse>("/admin/seo/connection/test", {});
    return res.data;
  },
  async sitemapPreview() {
    const res = await http.get<{
      sitemapUrl: string;
      entryCount: number;
      staticCount: number;
      productCount: number;
      generatedAt: string;
      previewUrls: string[];
      xml: string;
    }>("/admin/seo/sitemap");
    return res.data;
  },
  async sitemapXml() {
    const res = await http.get<string>("/admin/seo/sitemap?format=xml", {
      responseType: "text",
    });
    return res.data;
  },
  async submitSitemap() {
    const res = await http.post<SeoActionResponse>("/admin/seo/sitemap/submit", {});
    return res.data;
  },
  async syncLocalSitemap() {
    const res = await http.post<SeoActionResponse>("/admin/seo/sitemap/sync-local", {});
    return res.data;
  },
  async inspectUrl(url: string) {
    const res = await http.post<SeoActionResponse>("/admin/seo/inspect", { url });
    return res.data;
  },
  async runFullSync(inspectProductsLimit?: number) {
    const res = await http.post<SeoActionResponse>("/admin/seo/run-full-sync", {
      inspectProductsLimit,
    });
    return res.data;
  },
};
